import { setupApi } from '@calendly/segment'

class FeatureFlags {
  set(features) {
    Object.keys(features || {}).forEach((name) => {
      this[name] = features[name]
    })
  }

  isEnabled(featureName) {
    if (featureName.includes('booking.')) {
      const flags = featureName.split('.')

      return this[flags[0]][flags[1]]
    }

    return this[featureName]
  }

  initializeSegment() {
    return setupApi()
  }
}

export default new FeatureFlags()
